import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Nav, NavbarBrand, NavbarToggler, NavItem, NavLink, Badge, Form, Input, InputGroup, InputGroupAddon, Button } from 'reactstrap';
import HeaderDropdown from './HeaderDropdown';
import { config } from '../../constants/domainConfig';
import { showSearchBar, setHeaderTitle } from '../../actions/HeaderActions';
import { searchText } from '../../actions/SearchActions';
import { changeLangAction } from "../../actions/WelcomeActions";
import { MultiLangDomains } from "../../constants/multiLangSupport";
import BottomLangDropDown from '../BottomLangDropDown/BottomLangDropDown';
class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageTitle: this.props.header.title,
            openLangMenu:false
        };

        this.goBack = this.goBack.bind(this);
        this.searchOpen = this.searchOpen.bind(this);
        this.sidebarToggle = this.sidebarToggle.bind(this);
        this.mobileSidebarToggle = this.mobileSidebarToggle.bind(this);
        this.onChange = this.onChange.bind(this);
        this.clearText = this.clearText.bind(this);
        this.handleChangeLang = this.handleChangeLang.bind(this);
        this.closeLangMenu = this.closeLangMenu.bind(this);
    }


    componentDidMount() {
        this.props.showSearchBar(false);
        // this.hideSearchBar();
    }

    sidebarToggle(e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-hidden');
    }

    mobileSidebarToggle(e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-mobile-show');
    }

    goBack(e) {
        e.preventDefault();
        window.history.back();
    }

    searchOpen() {
        this.props.setHeaderTitle('');
        if((config.title=='es' || config.title === "bidiotv") && window.innerWidth <= 575){

            this.clearText();
            window.history.back();

        }
        else {
            this.props.showSearchBar(!this.props.header.showSearchBar);
            let searchInput = document.querySelector("#search");
            if (!this.props.header.showSearchBar) {
                searchInput.focus();
            } else {
                searchInput.blur();
            }
            this.clearText();
        }
    }

    clearText() {
        this.props.searchText('');
    }

    onChange(e) {
        this.props.searchText(e.target.value);
    }
    handleChangeLang(lang){
        this.props.changeLang(lang);
        this.props.changeLangAction({
            currentLang: lang
        });
    }
    toggleLangMenu(){
        this.setState({
            openLangMenu:!this.state.openLangMenu
        })
    }
    closeLangMenu(){
        this.setState({
            openLangMenu:false
        })
    }

    setHeaderTitle(){
         if(config.title == 'bidiotv' && config.mainDomain != 'mobiotv') {
             if(this.props.header.title != '' && this.props.header.title !='Video On Demand'){
                 return (
                     <NavbarBrand className={window.innerWidth <= 575 && (window.location.hash == '#/history' || window.location.hash == '#/account') ? "page-title page-title--left":"page-title"}>
                         <span className="white-text-color">{this.props.header.title}</span>
                     </NavbarBrand>
                 )
             } else {
                 return (
                     <NavbarBrand href={`/#/home?uid=${this.props.access.uid}`}>
                        <img className="logo-image" src="./img/logo/bidiotv-logo.png" alt="BidioTV" />
                     </NavbarBrand>
                 )
             }

        }
        else if(config.title == 'bidiotv' && config.mainDomain == 'mobiotv') {
            console.log("enter");
            if(this.props.header.title != '' && this.props.header.title !='Video On Demand'){
                return (
                    <NavbarBrand className={window.innerWidth <= 575 && (window.location.hash == '#/history' || window.location.hash == '#/account') ? "page-title page-title--left":"page-title"}>
                        <span className="white-text-color">{this.props.header.title}</span>
                    </NavbarBrand>
                )
            } else {
                console.log("enter here");
                return (
                    <NavbarBrand href={`/#/home?uid=${this.props.access.uid}`} className={config.subDomain==='iq' ? "navbar-brand-ar" :""}>
                       {config.newDomain === 'fitness-bay' ? <img className='logo-image-alt' src="./img/fitness-bay.png" /> : config.newDomain === 'fun-box' ? <img className='logo-image-alt' src="./img/funbox.svg" /> : <img className={config.subDomain==='iq' ? config.lang==='ar' ? "logo-image-right-ar logo-image":"logo-image-left-ar logo-image" :"logo-image"} src={(config.newDomain === 'telemovil') ?  "./img/telemovil.png" : config.newDomain === 'trendme' ? "./img/trendme.png" : config.newDomain === 'vidflixz' ? "./img/vidflixz.png" : config.newDomain === 'flamilingo' ? "./img/flamilingo.png" : config.newDomain ==='mobiofitplus' ? "./img/mobiotfit.png" : config.subDomain.includes('mobiofit')? "./img/logo/mobiofitlogo.svg" :  "./img/logo.png"} alt="MobioTV"  style={config.lang==='ar' ? {marginRight: '15px'}:{}}/>}
                    </NavbarBrand>
                )
            }

       }
        else if(config.title == 'es'){
             if(this.props.header.title != '' && this.props.header.title !='Video On Demand'){
                 return (
                     <NavbarBrand className={window.innerWidth <= 575 && (window.location.hash == '#/history' || window.location.hash == '#/account') ? "page-title page-title--left":"page-title"}>
                         <span className="white-text-color">{this.props.header.title}</span>
                     </NavbarBrand>
                 )
             }else {
                 return(
                     <NavbarBrand href={`/#/home?uid=${this.props.access.uid}`}>
                        <img className="logo-image" src="./img/logo.png" alt="BidioTV" />
                    </NavbarBrand>
                 )
             }
         }
        else if(config.mainDomain == 'mobiotv'){
             if(this.props.header.title != '' && this.props.header.title !='Video On Demand'){
                 return (
                     <NavbarBrand className="page-title">
                         <span className="white-text-color">{this.props.header.title}</span>
                     </NavbarBrand>
                 )
             }else {
                 return(
                     <NavbarBrand href={`/#/home?uid=${this.props.access.uid}`}>
                        <img className="logo-image" src="./img/logo.png" alt="MobioTV" />
                    </NavbarBrand>
                 )
             }
        }
        else{
            if(this.props.header.title != '') {
                return (
                    <NavbarBrand className="page-title">
                        <span className="white-text-color">{this.props.header.title}</span>
                    </NavbarBrand>
                )
            }
            else{
                return(
                    <NavbarBrand href={`/#/welcome?uid=${this.props.access.uid}`}>
                        <img className="logo-image" src="./img/logo.png" alt="MobioTV" />
                    </NavbarBrand>
                )
            }
        }

    }



    render() {
        const isAdmin = this.props.isAdmin;
        let showSearch = this.props.showSearch;
        let showMenu = this.props.showMenu;
        let searchPlaceholderText = {
          en: "Search...",
          es: "Buscar...",
          be: " Zoeken...",
          id: "Cari...",
          it: "Ricerca...",
          se: "Sök...",
          ar: "بحث",
          no:"Søk",
          ee:"Otsi..",
          tr:"Ara",
          lv:"Meklēt",
          lt:"Ieškoti",
          sr:"Тражи",
          th:"ค้นหา...",
          el:"Αναζήτηση...",
          de:"durchsuchen...",
          fr:"Recherche..",
          cs:"Vyhledávání...",
          pt:"Buscar"
        };
        let canceltext = {
          en: "Cancel",
          es: "Cancelar",
          be: "Annuleren",
          id: "Batal",
          it: "Annulla",
          se: "Avbryt",
          ar: "إلغاء",
          no:"Avbryt",
          ee:"Tühista",
          tr:"İptal",
          lv:"Atcelt",
          lt:"Atšaukti",
          sr:"Искључи",
          th:"ยกเลิก",
          el:"Αναζήτηση",
          de:"Abbrechen",
          fr:"Annuler",
          cs:"Zrušit",
          pt:"Cancelar"
        };
        return (
            <header className='app-header navbar'>
                <div className="inner-header">
                    <div className="container-fluid">
                        <div className="nav-row">
                            {!this.props.location.pathname.includes('/search') && <div className="nav-col">
                                <div className={config.subDomain==='iq' ? config.lang==='ar' ? "navbar-right" :"navbar-left navbar-left-ar": "navbar-left"}>
                                    {
                                        (config.title === "es" || config.title === "bidiotv") && window.innerWidth <= 575 && config.subDomain !== 'lv' ? ""
                                        :                             
                                        <NavbarToggler className="d-lg-none" onClick={this.mobileSidebarToggle}>
                                            <span className="icon-bar"></span>
                                            <span className="icon-bar"></span>
                                            <span className="icon-bar"></span>
                                        </NavbarToggler>  
                                    }
                                    
                                    <NavbarToggler className="d-md-down-none" style={{marginLeft: '10px'}} onClick={this.sidebarToggle}>
                                        <span className="icon-bar"></span>
                                        <span className="icon-bar"></span>
                                        <span className="icon-bar"></span>
                                    </NavbarToggler>
                                        
                                    
                                    {this.setHeaderTitle()}
                                    {config.subDomain==='iq' && window.innerWidth <= 575 && !['/search','/history','/account'].includes(this.props.location.pathname)?
                                        <div>
                                            <span className="lang" onClick={()=>this.handleChangeLang('ar')}>AR</span>
                                            <span className="lang" onClick={()=>this.handleChangeLang('en')}>EN</span>
                                        </div>:null
                                    }
                                    {
                                        (['ch'].indexOf(config.subDomain) >= 0) && window.innerWidth<=575 && ['/home'].includes(this.props.location.pathname) ?
                                        <div className="lang-button" onClick={()=>this.toggleLangMenu()}><i className='fa fa-language'></i>{" "}{config.lang}</div>
                                        :null
                                    }
                                    
                                </div>
                            </div>}

                            {(showSearch) ?

                            <div className="nav-col">
                                    <Nav className="navbar search-wrap">
                                        {isAdmin ?
                                            <HeaderDropdown logout={this.props.logout}/>
                                            :<NavItem className="search">
                                                <NavLink href="javascript:void(0);"></NavLink>
                                                <div id="search-box" className={(this.props.header.showSearchBar) ? "search-box search-box-toggle" : "search-box"}>
                                                    <InputGroup style={ {marginTop: '10px'}}>
                                                        <Input className="search__input" placeholder={searchPlaceholderText[config.lang] ||searchPlaceholderText.en } type="search" name="search" id="search" maxLength="50" value={this.props.search.searchText} onChange={this.onChange}/>
                                                        <div className="input-group-addon search__addon" onClick={(!this.props.header.showSearchBar) ? this.searchOpen : () => {}}>
                                                            <Button className="search__btn" ><img src="./img/search-icon.png" className="search-icon" /></Button>
                                                        </div>
                                                        <button className="search__addon--clear" onClick={this.clearText}><img className="search__clear" src="./img/close.svg" /></button>
                                                        {window.innerWidth > 575 ? <button className="search__addon--cancel" onClick={this.searchOpen}>{canceltext[config.lang] || canceltext.en}</button>:null}
                                                    </InputGroup>
                                                </div>
                                            </NavItem>
                                        }
                                    </Nav>
                                    
                             </div>
                             : ''}
                             {
                                 this.state.openLangMenu ?
                                 <BottomLangDropDown changeLang={this.props.changeLang} onClose={this.closeLangMenu} languageData={MultiLangDomains[config.subDomain]} />:null
                             }
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer,
        account: state.AccountReducer,
        category: state.CategoryReducer,
        country: state.CountryReducer,
        domain: state.DomainReducer,
        favorite: state.FavoriteReducer,
        flashmessage: state.FlashMessageReducer,
        header: state.HeaderReducer,
        historyVideos: state.HistoryReducer,
        loader: state.ActivityIndicatorReducer,
        play: state.PlayReducer,
        search: state.SearchReducer,
        smartTV: state.SmartTVReducer,
        splash: state.SplashScreenReducer,
        user: state.AuthenticationReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        searchText,
        showSearchBar,
        setHeaderTitle,
        changeLangAction
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);


// WEBPACK FOOTER //
// ./src/components/Header/Header.js